import {extractGDriveFolderIdFromUrl} from '@coolcolduk/google';

export function resolveOutputFolderId(outputFolderUrlOrId: string): string {
  const id = extractGDriveFolderIdFromUrl(outputFolderUrlOrId);
  if (id) return id;
  if (/^[a-zA-Z0-9-_]+$/.test(outputFolderUrlOrId)) return outputFolderUrlOrId;
  throw new Error('Invalid output folder URL or id');
}
